import { http } from '../api/http';
import type { Project, Development } from '../types/Project';
import { developmentToProject } from '../utils/projectAdapter';

export interface CreateInvestmentPayload {
  projectId: number;
  amount: number;
  currency: 'MXN' | 'USD';
  invoiceId: string;
  provider: 'paypal';
}

export interface CreateInvestmentResponse {
  ok: true;
  investmentId: number;
  status: 'Pendiente' | 'Aprobado' | 'Rechazado' | 'Activa';
}

export interface InvestmentGate {
  canInvest: boolean;
  kycRequired: boolean;
  pldRequired: boolean;
  kycStatus?: 'not_started' | 'pending' | 'approved' | 'rejected';
  pldStatus?: 'not_started' | 'pending' | 'approved' | 'rejected';
  reasons?: string[];
}

export const ProjectsService = {
  async getAll(options?: { scope?: 'public' | 'developer' }): Promise<Project[]> {
    if (options?.scope === 'developer') {
      const devResponse = await http<{ ok: boolean; data: Development[] }>('/developer/projects/full');
      const devDevelopments = devResponse.data || [];
      return devDevelopments.map(developmentToProject);
    }

    const response = await http<{ ok: boolean; data: Development[]; pagination?: any }>('/public/projects');
    const developments = response.data || [];
    // Filtrar solo proyectos activos y convertir
    return developments
      .filter(dev => dev.is_active === true)
      .map(developmentToProject);
  },

  async getById(id: number): Promise<Project> {
    const response = await http<{ ok: boolean; data: Development }>(`/public/projects/${id}`);
    return developmentToProject(response.data);
  },

  getInvestmentGate(projectId: number) {
    return http<InvestmentGate>(`/public/projects/${projectId}/investment-gate`);
  },

  createInvestment(payload: CreateInvestmentPayload) {
    return http<CreateInvestmentResponse>('/investments', { method: 'POST', body: payload });
  }
};
